import { Component, AfterViewInit, DoCheck, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ItemService } from '../../services/item/item.service';
import { LoginService } from "../../services/login/login.service";
import { LoggedinGuard } from '../../guards/loggedin.guard';
import { SyncGuard } from '../../guards/sync.guard';
import { TokenControlService } from "../../services/state/tokenControl.service";
import { WelcomeService } from "../../services/welcome/welcome.service";
import { ConfigurationService } from "../../services/configuration/configuration.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { ConfiguracionDTO } from '../../model/configuracion.dto';
import { RecaptchaV3Service } from "../../services/recaptcha-v3/recaptcha-v3.service";
import { Session } from '../../model/session';
import { WhiteListDTO } from '../../model/witheList.dto';
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { CONFIG } from '../../constants/constants';
import { OfflineService } from "../../services/data/offline.service";
import { UserState } from '../verificacion/verificacion.component';
import { TerritoriumService } from '../../services/territorium/territorium.service';
import { LogElectronService } from '../../services/logElectron/log-electron.service';
import { LOG_EVENT, LOG_LEVEL } from '../../model/eLogElectron';
import { SumadiData } from '../../model/lti-launch';
import { EncryptionService } from '../../services/data/encryption.service';
import { LtiService } from '../../services/LTI/lti.service';
import { Mask, MaskService } from '../../services/mask/mask.service';


// declare var grecaptcha: any;
declare var $: any;
// declare var captchaRef: any;


@Component({
  selector: 'app-root',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [ItemService, LoginService, ConfigurationService]
})
//Controlador de pagina de Login
export class LoginComponent implements AfterViewInit {

  public cap: any;

  //nombre de usuario que se loguea
  public user: string;

  //contraseña ingresada
  public password: string;

  //Indica si se presento un error en el login
  public errorLogin: boolean;

  //Flag que se encarga de mostrar el spinner mientras se hace el login
  public loading = false;

  //Mensaje de error general para problemas en el login
  public messageError: string;

  //lenguaje del navegador
  public defaultLanguage: string;

  //Tipo de texto en Input de contraseña
  public passwordType: String;

  //Define el tipo de ícono en Input de contraseña
  public passwordIcon: String;

  /**Bandera para mostrar el boton login */
  public showLogin: Boolean;

  /** Representa existencia en lsitas blancas */
  public whiteList: Boolean;

  /** Identificador de despliegue para verificar */
  public despliegue: string;

  /** Flag para determinar si esta online u offline */
  public plexiOnline: boolean;

  //@ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;

  // Nuevo método para cambiar el idioma (replicando la lógica de web.tour.component.ts)
  public changeLang(lang: string) {
    this._translateService.use(lang);
    localStorage.setItem('language', lang); // Opcional: Guarda el idioma seleccionado en localStorage para persistencia
  }

  //Constructor de la clase
  constructor(private _router: Router,
    private _loginService: LoginService,
    private _tokenController: TokenControlService,
    private _loggedinGuard: LoggedinGuard,
    private _syncGuard: SyncGuard,
    private _welcomeDataService: WelcomeService,
    private _translateService: TranslateService,
    private _configurationService: ConfigurationService,
    public _configurationControlService: ConfigurationControlService,
    private _recaptchaService: RecaptchaV3Service,
    private _offlineService: OfflineService,
    private _territoriumService: TerritoriumService,
    private _logElectronService: LogElectronService,
    private _encryptionService: EncryptionService,
    private _ltiService: LtiService,
    private _maskService: MaskService
  ) {
    this.errorLogin = false;
    this.messageError = '';
    this.getNavigatorLang();
    this.getPublicIp();
    this._configurationControlService.sessionInfo = new Session("", "", new Date(), null, null);
    this._translateService.addLangs(["es", "en"]);
    this._translateService.use(this.defaultLanguage);
    this.passwordType = 'password';
    this.passwordIcon = 'open';
    this._configurationControlService.esDemo = false;
    this.whiteList = false;
    this.despliegue = "20191108-1";
    this.plexiOnline = CONFIG.ONLINE;
  }
  /**
   * Método a ejecutarse en la inicialización de la página.
   */
  ngOnInit() {
    console.log(this.despliegue);
    //this._configurationService.inhabilitarBotonAtras();
    this.showLogin = true;
    this.loading = false;
    this.errorLogin = false;
    this._configurationService.inhabilitarBotonAtras();
    var is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (!is_chrome) {
      this.showLogin = false;
      //alert("Este explorador no está soportado, por favor acceda desde Google Chrome.")
    }
    this.getPublicIp();
  }

  /*Se encarga de consultar el idioma del navegador*/
  private getNavigatorLang() {
    this.defaultLanguage = this._translateService.getBrowserLang();
    if (this.defaultLanguage != 'es' && this.defaultLanguage != 'en') {
      this.defaultLanguage = 'es';
    }
  }


  //Necesario debido a la implementacion de la interfaz AfterViewInit
  public ngAfterViewInit() {
    //TODO: do something or delete method and interface
    this._maskService.setMask(Mask.basicMask, false);
  }

  //Se encarga de cambiar el tipo de texto en el campo Contraseña
  public loadTypePassword() {
    if (this.passwordType == 'password') {
      this.passwordType = 'text';
      this.passwordIcon = 'close';
    }
    else {
      this.passwordType = 'password'
      this.passwordIcon = 'open';
    }
  }

  /** Método encargado de ejecutar el recaptcha y solicitar el score */
  public recaptcha(): void {
    this.loading = true;
    let self = this;
    this._recaptchaService.execute('login', this._configurationControlService.publicIp).then((result: string) => {
      let whiteListDTO = new WhiteListDTO(self._configurationControlService.publicIp, result);

      self._loginService.verifyWhiteList(whiteListDTO).then(res => {
        if (res == "true") {
          this.login();
        } else {
          this.errorRecaptcha();
        }
      })
    });
  }

  /*Metodo principal de la vista, se encarga de realizar un intento
    de login. 1. valida que el captcha haya sido resuelto
    2. valida ingreso de credenciales 3. invoca una promesa del
    servicio de login, cuando la promesa resuelve trae en su respuesta
    el token generado por plexi-rest 4. modifica los flag del guard
    correspondiente segun el usuario 5. invoca otra promesa para
    cargar los datos de bienvenida del usuario, cuando esta promesa
    resuelve se navega a la pagina correspondiente dependiendo del tipo
    de usuario*/
  public login(): void {
    this.loading = true;
    let self = this;
    if (this.validateCredentials()) {
      this._loginService.login(this.user.toLowerCase(), this.password, self._configurationControlService.publicIp).then(result => {
        if (result == null) {
          this.errorAutenticate();
          return;
        }

        if (result.estado == 1) {
          self._loggedinGuard.loggedIn = true;
          self._tokenController.token = result;
          sessionStorage.removeItem('uuidSesion');
          sessionStorage.setItem('uuidSesion', self._tokenController.token.uuidSesion);
          if (result.userType == 2) {
            self._syncGuard.canSync = true;
          }
          self._loginService.saveToken(result);
          let route = null;
          if (result.userType == 1 || result.userType === 5 || result.userType === 6) {
            route = '/welcome';
            self._loginService.loadWelcomeInfo(
              self._tokenController.token.credentialId,
              self._tokenController.token.token,
              self._tokenController.token.tokenId,
              self._configurationControlService.examConfiguration != null ? self._configurationControlService.examConfiguration.multiplesesion : false)
              .then(res => {
                self._welcomeDataService.data = res;//self._welcomeDataService.data.discapacidad=true;
                let idCombo = self._welcomeDataService.data.idCombo;
                self._configurationService.loadExamConfiguration(idCombo,
                  self._tokenController.token.token,
                  self._tokenController.token.tokenId)
                  .then(data => {

                    self._configurationControlService.examConfiguration = data;
                    self.loading = false;
                    self._configurationControlService.sessionInfo.ipPublica = self._configurationControlService.publicIp;
                    self._configurationControlService.sessionInfo.fechaIngreso = new Date();
                    self._configurationControlService.sessionInfo.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.sessionInfo.sesion = null;
                    try {
                      self._logElectronService.saveLog(LOG_LEVEL.INFO, LOG_EVENT.E_LOGIN, `credentialId=${self._tokenController.token.credentialId}`)
                    } catch (error) { }
                    self._loginService.saveSessionInfo(self._tokenController.getTokenValue(), self._tokenController.token.tokenId + "", ESTADO_SESSION_INFO.LOGIN);
                    self._configurationControlService.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.online = true;

                    if (data.securityterri && data.securityterri === true) {
                      this.verificarPreregistro(this._tokenController.token.credentialId + "", self._tokenController.token.token, self._tokenController.token.tokenId);
                      return;
                    }
                    if (data.securitySumadi && data.securitySumadi === true) {
                      this.createSumadiData();
                      this._welcomeDataService.ltiInformation = Object.assign({}, this._welcomeDataService.data);
                      this._welcomeDataService.ltiInformation.tokenId = this._tokenController.token.tokenId;
                      this._welcomeDataService.ltiInformation.credentialId = this._tokenController.token.credentialId;
                      if (this._welcomeDataService.ltiInformation.identificacion) {
                        this._welcomeDataService.ltiInformation.identificacion = this._welcomeDataService.ltiInformation.identificacion.substr(2);
                      }
                      console.log("su_login_user", this._welcomeDataService.ltiInformation)

                      self._router.navigate(['/welcome']);
                      //self._router.navigate(['/lti-start']);
                      return;
                    }

                    self._router.navigate(['/welcome']);

                  })

              });
          } else if (result.userType == 2) {
            self._configurationControlService.examConfiguration = new ConfiguracionDTO("1", "NINGUNO", false, false, false, false, false, "es", false, false, false, false, false, false, null, false, false, false, false, true, false, false, false, false, false);
            self._syncGuard.canSync = true;
            self._router.navigate(['/sync']);
          } else if (result.userType == 3) {
            self._configurationControlService.examConfiguration = new ConfiguracionDTO("1", "NINGUNO", false, false, false, false, false, "es", false, false, false, false, false, false, null, false, false, false, false, true, false, false, false, false, false);
            self._router.navigate(['/uploadFiles']);
          } else if (result.userType == 4) {
            self._loggedinGuard.loggedIn = true;
            self._tokenController.token = result;
            //sessionStorage.setItem('uuidSesion', self._tokenController.token.uuidSesion);
            self._loginService.saveToken(result);
            self._loginService.loadWelcomeInfo(
              self._tokenController.token.credentialId,
              self._tokenController.token.token,
              self._tokenController.token.tokenId,
              self._configurationControlService.examConfiguration != null ? self._configurationControlService.examConfiguration.multiplesesion : false)
              .then(res => {
                self._welcomeDataService.data = res;
                this._welcomeDataService.ltiInformation = Object.assign({}, this._welcomeDataService.data);
                this._welcomeDataService.ltiInformation.tokenId = this._tokenController.token.tokenId;
                this._welcomeDataService.ltiInformation.credentialId = this._tokenController.token.credentialId;
                self._router.navigate(['/lti-start']);
              });
          }
        } else {
          if (result == null || result.credentialId == null) {
            self.messageError = result.message;
          } else {
            self.messageError = result.message;
          }
          self.loading = false;
          self.errorLogin = true;
        }
      }, err => {
        if (err.error && err.status == 400) {
          self.messageError = err.error.message;
        } else {
          self.messageError = "Error al intentar conectar con el servicio."
        }
        self.loading = false;
        self.errorLogin = true;
      });
    } else {
      this.errorAutenticate();
    }
  }

  private createSumadiData() {
    if (!this._ltiService.sumadiData) {
      this.createLocalData();
    } else {
      const stringSaved = this._ltiService.sumadiData.split('*UuvuU*');
      const sumadiData: SumadiData =
        JSON.parse(this._encryptionService.decryptDataSumadi(stringSaved[0], stringSaved[1]));
      if (sumadiData.username != this.user.toLowerCase()) {
        this.createLocalData();
      }
    }
  }

  private createLocalData() {

    const key = `${new Date().getTime()}`;

    const sumadiData: SumadiData = {
      username: this.user.toLowerCase(),
      password: this.password,
      sessions: []
    };

    const encriptedData = this._encryptionService.encryptDataSumadi(JSON.stringify(sumadiData), key);

    this._ltiService.sumadiData = `${encriptedData}*UuvuU*${key}`;
  }

  verificarPreregistro(credencial: string, token: string, user: string) {
    let self = this;
    this._territoriumService.validarPreregistro(credencial, token, user).then((response: number) => {
      if (response === UserState.REGISTERED || response === UserState.INVERIFICATION) {
        self._router.navigate(['/welcome']);
      }
      if (response === UserState.UNREGISTERED) {
        self._router.navigate(['/verification']);
      }
    })
  }



  public loginOffline() {

    let self = this;
    if (this.validateCredentials()) {
      this._offlineService.loginOffline(this.user.toLowerCase(), this.password).then(result => {
        if (result == null) {
          this.errorAutenticate();
          return;
        }
        if (result.estado == 1) {
          self._loggedinGuard.loggedIn = true;
          self._tokenController.token = result;

          this._loginService.saveToken(result);
          let route = null;
          if (result.userType == 1 || result.userType == 5) {
            route = '/welcome';
            this._offlineService.getWelcomeDTO(
              self._tokenController.token.credentialId,
              self._tokenController.token.token,
              self._tokenController.token.tokenId)
              .then(res => {
                self._welcomeDataService.data = res;//self._welcomeDataService.data.discapacidad=true;
                const idCombo = self._welcomeDataService.data.idCombo;
                self._offlineService.getConfigiracionExamen(idCombo,
                  self._tokenController.token.token,
                  self._tokenController.token.tokenId)
                  .then(data => {
                    //data.tourTest = "ESTANDAR";
                    data.language = data.language ? data.language : "es";
                    //data.showSimulation = true;
                    //data['chrono'] = true;
                    self._configurationControlService.examConfiguration = data;
                    self.loading = false;
                    self._configurationControlService.sessionInfo.ipPublica = self._configurationControlService.publicIp;
                    self._configurationControlService.sessionInfo.fechaIngreso = new Date();
                    self._configurationControlService.sessionInfo.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.sessionInfo.sesion = null;
                    // self._loginService.saveSessionInfo(self._tokenController.getTokenValue(), self._tokenController.token.tokenId, ESTADO_SESSION_INFO.LOGIN);
                    try {
                      self._logElectronService.saveLog(LOG_LEVEL.INFO, LOG_EVENT.E_LOGIN, `credentialId=${self._tokenController.token.credentialId}`)
                    } catch (error) { }
                    self._configurationControlService.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.online = true;
                    self._router.navigate(['/welcome']);
                  })

              });
          }
        }
      }).catch((e) => {
        self.messageError = "Valide las credenciales."
        self.loading = false;
        self.errorLogin = true;

      })
    }
  }


  public errorAutenticate() {
    let self = this;
    this._translateService.get('mensaje.usuario.no.valido')
      .subscribe((res: string) => {
        self.messageError = res;
      });
    self.loading = false;
    self.errorLogin = true;
  }

  //Se encarga de validar que las credenciales no sean nulas
  public validateCredentials(): boolean {
    let valid = true;
    if (!this.user || this.user.trim() == "") {
      valid = false;
    }
    if (!this.password || this.password.trim() == "") {
      valid = false;
    }
    return valid
  }

  /*Metodo encargado de consultar la ip del cliente para almacenarla
  en el objeto respuesta*/
  public getPublicIp() {
    let self = this;
    this._loginService.getIp().then(res => {
      self._configurationControlService.publicIp = res['ip'];
      this.verifiSumadiIntegration();
    })
  }

  enterPreIcfes() {
    this._router.navigate(["/preIcfes"]);
    this._configurationControlService.ambiente = "preIcfes";
  }

  enterDemo() {
    this._router.navigate(["/demo"]);
    this._configurationControlService.ambiente = "demo";
  }

  private verifiSumadiIntegration() {
    try {
      if (this._ltiService.sumadiData) {
        const stringSaved = this._ltiService.sumadiData.split('*UuvuU*');
        const sumadiData: SumadiData =
          JSON.parse(this._encryptionService.decryptDataSumadi(stringSaved[0], stringSaved[1]));
        this.user = sumadiData.username;
        this.password = sumadiData.password;
        this.login();
      }
    } catch (error) {
      throw new Error("Error Sumadi integration " + error);
    }
  }

  /** Método encargado de manejar el error en el recaptcha */
  public errorRecaptcha() {
    let self = this;
    this._translateService.get('mensaje.usuario.no.humano')
      .subscribe((res: string) => {
        self.messageError = res;
      });
    self.loading = false;
    self.errorLogin = true;
  }

  public loginButton() {
    return this.plexiOnline ?
      this._configurationControlService.showCaptcha ? this.recaptcha() : this.login()
      : this.loginOffline();
  }
}
